import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { withRouter } from 'react-router-dom';
import * as selectors from "../../api/selectors";
import { COLORS } from '../../theme';

import "../../mobile.css";
const MainLayout = ({ children, isPending, location }) => {


  const style = {
    'background': `linear-gradient(180deg, #ffff 10%, ${COLORS.theme} 99%)`
  }



  let title = location.pathname.replace(/\//g, "");
  const applyCss = (title === 'dashboard') ? style : { border: '0px solid transprent' };
  // ReduxToastr.confirm('You have timed out! Please log back in.', options);
  return (
    <div className="mainContainer" style={applyCss}>
      <ReduxToastr
        timeOut={8000}
        newestOnTop={false}
        preventDuplicates
        position="top-right"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick
      />
      {children}
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.object.isRequired,
  isPending: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    isPending: selectors.getIsPending(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MainLayout));
